import styles from "@/styles/modules/components/contact/ModuleMaps.module.scss";
import { Link as LinkType } from "@/types/wordpress-parts";
import Link from "next/link";

interface ModuleMapsProps {
  mapIframe: string | null;
  mapLink: LinkType;
}

export default function ModuleMaps({ mapIframe, mapLink }: ModuleMapsProps) {
  return (
    <section className={styles.moduleMaps}>
      <div className={styles.moduleMapsContainer}>
        {mapIframe && <iframe src={mapIframe} />}
        <Link href={mapLink.url} target={mapLink.target}>
          {mapLink.title}
        </Link>
      </div>
    </section>
  );
}
